import { Component } from "react"

/* Components */
import { Icon } from "../../components"

/* Moment */
import moment from "moment"

/* Constants */
import { env } from "../../constants"

/* Helpers */
import { utils } from "../../helpers"

/* Shared */
import { SOCIALS, line, metric, number } from "./shared"


/* Widget Info Tab — the numbers of the point first, everything the base keeps about it after,
   and at the very bottom the three things which are done to the point itself */
class InfoTab extends Component {

    render = () => {

        /* Fields */
        const { data, onQr, onToggle } = this.props
        const { organization, statistics, categories, images, owner, payments } = data

        /* What the client finds at the point — the card keeps the list as text, the backend reads it */
        const amenities = utils.check(data.amenities, [])

        const bookings = statistics.bookings
        const rating = number(statistics.reviews.rating)

        /* The links of the point which are filled in */
        const socials = SOCIALS.filter(social => organization[social.key] && `${organization[social.key]}`.length > 0)

        return (
            <div className="organization-details-body">

                <div className="organization-details-metrics">
                    {metric("Всего записей", number(bookings.total))}
                    {metric("Завершено", number(bookings.completed), "green")}
                    {metric("Отменено", number(bookings.cancelled) + number(bookings.missed), "red")}
                    {metric("Выручка", utils.convertor(Math.round(number(bookings.revenue)), "₸", 1), "blue")}
                    {metric("Записей за месяц", number(bookings.monthBookings))}
                    {metric("Выручка за месяц", utils.convertor(Math.round(number(bookings.monthRevenue)), "₸", 1))}
                    {metric("Клиентов в базе", number(statistics.clients.total))}
                    {metric("Рейтинг", rating > 0 ? `${rating.toFixed(1)} ★` : "Нет оценок")}
                    {metric("Отзывов", number(statistics.reviews.total))}
                    {metric("Мастеров", `${statistics.members.active} из ${statistics.members.total}`)}
                    {metric("Услуг", `${statistics.services.active} из ${statistics.services.total}`)}
                    {metric("Показов телефона", number(statistics.phoneViews))}
                </div>

                {organization.serviceMode === "QUEUE_BASED" &&
                    <div className="organization-details-metrics">
                        {metric("В очереди всего", number(statistics.queue.total))}
                        {metric("Ожидают", number(statistics.queue.waiting), "orange")}
                        {metric("Обслужено", number(statistics.queue.done), "green")}
                        {metric("Не пришли", number(statistics.queue.missed) + number(statistics.queue.cancelled), "red")}
                    </div>
                }

                <div className="organization-details-columns">

                    <div className="organization-details-column">

                        <div className="organization-details-section">
                            <div className="organization-details-section-text">Контакты</div>
                            {line("Телефон", organization.phone)}
                            {line("Город", organization.city)}
                            {line("Адрес", organization.address)}
                            {line("Координаты", organization.lat && organization.lng ? `${organization.lat}, ${organization.lng}` : null, organization.lat && organization.lng ? `https://2gis.kz/geo/${organization.lng},${organization.lat}` : null)}
                            {line("ИИН / БИН", organization.iin)}
                            {line("Показов телефона", organization.phoneViews)}
                        </div>

                        {owner &&
                            <div className="organization-details-section">
                                <div className="organization-details-section-text">Владелец</div>
                                {line("Имя", owner.name)}
                                {line("Телефон", owner.phone)}
                                {line("Email", owner.email)}
                                {line("В команде с", owner.createdAt ? moment(owner.createdAt).format("DD MMMM YYYY") : null)}
                            </div>
                        }

                        <div className="organization-details-section">
                            <div className="organization-details-section-text">Категории</div>
                            <div className="organization-details-chips">
                                {categories.length > 0
                                    ? categories.map(category => <div key={`${category.id}`} className="organization-details-chip">{category.name}</div>)
                                    : <div className="organization-details-empty">Категории не выбраны</div>
                                }
                            </div>
                        </div>

                        <div className="organization-details-section">
                            <div className="organization-details-section-text">Способы оплаты</div>
                            <div className="organization-details-chips">
                                {payments.length > 0
                                    ? payments.map(payment => <div key={`${payment.id}`} className="organization-details-chip">{payment.name}</div>)
                                    : <div className="organization-details-empty">Не указаны</div>
                                }
                            </div>
                        </div>

                        {amenities.length > 0 &&
                            <div className="organization-details-section">
                                <div className="organization-details-section-text">Удобства</div>
                                <div className="organization-details-chips">
                                    {amenities.map((amenity, index) => <div key={`${index}`} className="organization-details-chip">{amenity}</div>)}
                                </div>
                            </div>
                        }

                    </div>

                    <div className="organization-details-column">

                        {socials.length > 0 &&
                            <div className="organization-details-section">
                                <div className="organization-details-section-text">Ссылки</div>
                                {socials.map(social => line(social.text, organization[social.key], `${organization[social.key]}`.indexOf("http") === 0 ? organization[social.key] : null))}
                            </div>
                        }

                        {organization.description &&
                            <div className="organization-details-section">
                                <div className="organization-details-section-text">Описание</div>
                                <div className="organization-details-description">{organization.description}</div>
                            </div>
                        }

                        {images.length > 0 &&
                            <div className="organization-details-section">
                                <div className="organization-details-section-text">Фотографии — {images.length}</div>
                                <div className="organization-details-images">
                                    {images.map((image, index) =>
                                        <div key={`${index}`} className="organization-details-image">
                                            <img src={`${env.mediapoint}organizations/${image.image}`} alt="Organization" />
                                            {image.main && <div className="organization-details-image-main">Главная</div>}
                                        </div>
                                    )}
                                </div>
                            </div>
                        }

                        <div className="organization-details-section">
                            <div className="organization-details-section-text">Системная информация</div>
                            {line("ID", organization.id)}
                            {line("UID", organization.uid)}
                            {line("Ссылка", organization.url, `https://i.bookify.kz/g/${organization.uid}`)}
                            {line("Режим работы", organization.serviceMode === "QUEUE_BASED" ? "Электронная очередь" : "Запись по времени")}
                            {line("Виден в приложении", parseInt(organization.visible) === 1 ? "Да" : "Нет")}
                            {line("Подарочные сертификаты", parseInt(organization.gift) === 1 ? "Подключены" : "Отключены")}
                            {line("Язык WhatsApp", organization.whatsappLanguage === "kk" ? "Қазақша" : (organization.whatsappLanguage === "ru" ? "Русский" : "Как на платформе"))}
                            {line("Первая запись", bookings.firstBooking ? moment(bookings.firstBooking).format("DD.MM.YYYY") : null)}
                            {line("Последняя запись", bookings.lastBooking ? moment(bookings.lastBooking).format("DD.MM.YYYY HH:mm") : null)}
                            {line("Создан", organization.createdAt ? moment(organization.createdAt).format("DD MMMM YYYY, HH:mm") : null)}
                            {line("Обновлён", organization.updatedAt ? moment(organization.updatedAt).format("DD MMMM YYYY, HH:mm") : null)}
                        </div>

                        <div className="organization-details-section">

                            <div className="organization-details-section-text">Действия</div>
                            <div className="organization-details-hint">Постер печатается для стойки заведения. Отключённая точка пропадает из приложения и из поиска.</div>

                            <div className="organization-details-buttons">

                                <div onClick={() => onQr(organization)} className="organization-details-action">
                                    <Icon name="qr" size={16} />
                                    <span>QR код</span>
                                </div>

                                <div onClick={() => onToggle(organization)} className="organization-details-action">
                                    <Icon name="power" size={16} />
                                    <span>{parseInt(organization.visible) === 1 ? "Отключить" : "Включить"}</span>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
        )
    }
}

export default InfoTab
